<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="purchasing-qual-management-tab" :class="{ 'form-disabled': disabled }">
    <div class="row">
      <!-- Purchasing (FORM02: purchasing_quality_management.cat_emcr_purchasings) -- baris = baris tabel Plant (`rows_from`). -->
      <div v-if="isTableVisible(PURCHASING_QM_TAB, PURCHASINGS_FIELD)" :class="showInspections ? 'col-md-6' : 'col-12'">
        <div class="card h-100">
          <div class="card-header py-3 pb-2" style="padding-left: 1rem">
            <h6 class="mb-0 fw-semibold">Purchasing</h6>
            <small class="text-muted">Rows follow the Plant table in the Plant &amp; Storage Location tab.</small>
          </div>
          <div class="card-body pt-0 px-0 card-body-tab">
            <DataTable :value="dialog.form[PURCHASINGS_FIELD] || []" class="p-datatable-sm p-datatable-gridlines" scrollable scroll-height="420px">
              <template v-for="col in PURCHASING_COLUMNS" :key="col.column">
                <Column v-if="isColumnVisibleFn(col.column, PURCHASINGS_FIELD, PURCHASING_QM_TAB)" header-class="bg-light text-center" :style="columnWidth(col.width)">
                  <template #header>
                    {{ col.label }} <span v-if="isColumnMandatoryFn(col.column, PURCHASINGS_FIELD, PURCHASING_QM_TAB)" class="exclamation-mark-error-tab">*</span>
                  </template>
                  <template #body="{ data }">
                    <SelectPrime show-clear v-if="col.type === 'select'" v-model="data[col.column]" size="small" fluid :filter="col.filter"
                      :options="dialog.options[columnOptionsKey(PURCHASING_QM_TAB, PURCHASINGS_FIELD, col.column, data)]"
                      option-label="label" option-value="value" :placeholder="`Select ${col.label}`"
                      :loading="dialog.loading[columnOptionsKey(PURCHASING_QM_TAB, PURCHASINGS_FIELD, col.column, data)]"
                      :invalid="isColumnInvalidFn(data, col.column)"
                      :disabled="disabled || col.readonly || !isColumnEnabledFn(col.column, PURCHASINGS_FIELD, PURCHASING_QM_TAB)"
                      @show="loadColumnOptions(PURCHASING_QM_TAB, PURCHASINGS_FIELD, col.column, data)"
                      @change="onColumnChange(PURCHASING_QM_TAB, PURCHASINGS_FIELD, col.column, data)"
                    >
                      <template #value="{ value, placeholder }">
                        <span v-if="value != null && value !== ''">{{ getSelectValueLabelFn(dialog.options[columnOptionsKey(PURCHASING_QM_TAB, PURCHASINGS_FIELD, col.column, data)], value) }}</span>
                        <span v-else>{{ placeholder }}</span>
                      </template>
                    </SelectPrime>
                    <div v-else-if="col.type === 'checkbox'" class="text-center">
                      <Checkbox v-model="data[col.column]" :binary="true" true-value="X" :false-value="null"
                        :disabled="disabled || !isColumnEnabledFn(col.column, PURCHASINGS_FIELD, PURCHASING_QM_TAB)"
                      />
                    </div>
                  </template>
                </Column>
              </template>
              <template #empty>
                <div class="text-muted text-center small py-3">No plant yet. Add a plant in the Plant &amp; Storage Location tab.</div>
              </template>
            </DataTable>
          </div>
        </div>
      </div>

      <!-- Quality Management (FORM02: purchasing_quality_management.cat_emcr_inspections) -->
      <div v-if="showInspections" class="col-md-6">
        <div class="card h-100">
          <div class="card-header py-3 pb-2 d-flex align-items-center justify-content-between" style="padding-left: 1rem">
            <h6 class="mb-0 fw-semibold">
              Quality Management <span v-if="isTableMandatory(PURCHASING_QM_TAB, INSPECTIONS_FIELD)" class="exclamation-mark-error-tab">*</span>
            </h6>
            <ButtonPrime v-if="canAddRow(PURCHASING_QM_TAB, INSPECTIONS_FIELD)" icon="pi pi-plus" label="Add" size="small" :disabled="disabled" @click="addRow(PURCHASING_QM_TAB, INSPECTIONS_FIELD)" />
          </div>
          <div class="card-body pt-0 px-0 card-body-tab">
            <DataTable :value="dialog.form[INSPECTIONS_FIELD] || []" class="p-datatable-sm p-datatable-gridlines" scrollable scroll-height="420px">
              <template v-for="col in INSPECTION_COLUMNS" :key="col.column">
                <Column v-if="isColumnVisibleFn(col.column, INSPECTIONS_FIELD, PURCHASING_QM_TAB)" header-class="bg-light text-center" :style="columnWidth(col.width)">
                  <template #header>
                    {{ col.label }} <span v-if="isColumnMandatoryFn(col.column, INSPECTIONS_FIELD, PURCHASING_QM_TAB)" class="exclamation-mark-error-tab">*</span>
                  </template>
                  <template #body="{ data }">
                    <!-- Plant: opsi = plant di tabel Plant (data_source detail_array, source "form"), sama seperti tabel Location. -->
                    <SelectPrime show-clear v-if="col.type === 'select'" v-model="data[col.column]" size="small" fluid
                      :options="dialog.options[columnOptionsKey(PURCHASING_QM_TAB, INSPECTIONS_FIELD, col.column, data)]"
                      option-label="label" option-value="value" :placeholder="`Select ${col.label}`"
                      :invalid="isColumnInvalidFn(data, col.column)"
                      :disabled="disabled || !isColumnEnabledFn(col.column, INSPECTIONS_FIELD, PURCHASING_QM_TAB)"
                      @show="loadColumnOptions(PURCHASING_QM_TAB, INSPECTIONS_FIELD, col.column, data)"
                      @change="onColumnChange(PURCHASING_QM_TAB, INSPECTIONS_FIELD, col.column, data)"
                    >
                      <template #value="{ value, placeholder }">
                        <span v-if="value != null && value !== ''">{{ getSelectValueLabelFn(dialog.options[columnOptionsKey(PURCHASING_QM_TAB, INSPECTIONS_FIELD, col.column, data)], value) }}</span>
                        <span v-else>{{ placeholder }}</span>
                      </template>
                    </SelectPrime>
                    <InputNumber v-else-if="col.type === 'number'" :model-value="toNumberValue(data[col.column])" size="small" placeholder="0" :use-grouping="false" :min="0" fluid
                      :invalid="isColumnInvalidFn(data, col.column)"
                      :disabled="disabled || !isColumnEnabledFn(col.column, INSPECTIONS_FIELD, PURCHASING_QM_TAB)"
                      @update:model-value="data[col.column] = $event"
                    />
                    <div v-else-if="col.type === 'checkbox'" class="text-center">
                      <Checkbox v-model="data[col.column]" :binary="true" true-value="X" :false-value="null"
                        :disabled="disabled || !isColumnEnabledFn(col.column, INSPECTIONS_FIELD, PURCHASING_QM_TAB)"
                      />
                    </div>
                  </template>
                </Column>
              </template>
              <Column v-if="canRemoveRow(PURCHASING_QM_TAB, INSPECTIONS_FIELD)" header-class="bg-light" style="width: 56px">
                <template #body="{ index }">
                  <ButtonPrime icon="pi pi-trash" severity="danger" text size="small" :disabled="disabled" @click="removeRow(INSPECTIONS_FIELD, index)" />
                </template>
              </Column>
              <template #empty>
                <div class="text-muted text-center small py-3">No quality management data yet.</div>
              </template>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cataloguerTabMixin, useCataloguerTabEngine, createTabDialog } from "./New_CataloguerTab";

// Key tab & field repeatable di FORM02_BASE.json
const PURCHASING_QM_TAB = "purchasing_quality_management";
const PURCHASINGS_FIELD = "cat_emcr_purchasings";
const INSPECTIONS_FIELD = "cat_emcr_inspections";

// Layout kolom (urutan, label, jenis input) -- hardcode di Vue sesuai prinsip "layout hardcode, behavior dynamic".
// Tampil/wajib/enabled/opsi tiap kolom dari config FORM02. Checkbox disimpan "X" / null.
// Plant Purchasing `readonly`: penanda baris (diisi dari tabel Plant, `rows_from`), sama seperti tab MRP.
const PURCHASING_COLUMNS = [
  { column: "plant", label: "Plant", type: "select", width: 160, readonly: true },
  { column: "pur_group", label: "Purchasing Group", type: "select", width: 220, filter: true },
  { column: "automation_po", label: "Automation PO", type: "checkbox", width: 130 },
  { column: "critical_part", label: "Critical Part", type: "checkbox", width: 120 }
];

const INSPECTION_COLUMNS = [
  { column: "plant", label: "Plant", type: "select", width: 150 },
  { column: "inspection_type", label: "Inspection Type", type: "select", width: 220 },
  { column: "inspect_percentage", label: "Inspect Percentage", type: "number", width: 150 },
  { column: "q_score_procedure", label: "Q Score Procedure", type: "select", width: 160 },
  { column: "inspect_with_task_list", label: "Inspect with Task List", type: "checkbox", width: 150 },
  { column: "post_to_qi_stock", label: "Post To QI Stock", type: "checkbox", width: 140 },
  { column: "automatic_assignment", label: "Automatic Assignment", type: "checkbox", width: 150 },
  { column: "inspect_charcs", label: "Inspect Charcs", type: "checkbox", width: 120 },
  { column: "skips_allowed", label: "Skips Allowed", type: "checkbox", width: 120 },
  { column: "inspect_type_matl_active", label: "Inspect Type Matl Active", type: "checkbox", width: 170 },
  { column: "preferred_insp_type", label: "Preferred Insp Type", type: "checkbox", width: 150 }
];

// Props, setup engine, dialog, bind ke mcrItem, addRow/removeRow/opsi kolom: kerangka bersama New_CataloguerTab.js.
export default {
  name: "PurchasingQualManagement",
  mixins: [cataloguerTabMixin],
  setup(props) {
    return useCataloguerTabEngine(props, (vm) => ({
      // data_source detail_array dengan source "form" (opsi Plant di tabel Quality Management) dibaca dari state item ini.
      getDetailSources: () => ({ form: vm.dialog.form })
    }));
  },
  data() {
    return {
      PURCHASING_QM_TAB,
      PURCHASINGS_FIELD,
      INSPECTIONS_FIELD,
      PURCHASING_COLUMNS,
      INSPECTION_COLUMNS,
      dialog: createTabDialog(this.mcrItem)
    };
  },
  computed: {
    // Tidak tampil -> tabel Purchasing melebar penuh (col-12).
    showInspections() {
      return this.isTableVisible(PURCHASING_QM_TAB, INSPECTIONS_FIELD);
    }
  },
  methods: {
    columnWidth(width) {
      return { width: `${width}px`, minWidth: `${width}px` };
    },
    // Hook kerangka bersama, dipanggil tiap item dipilih/berganti. cat_emcr_purchasings sudah di-link ke cat_emcr_plants
    // oleh New_CataloguerForm.hydrateItem (rows_from) -- ensureTableArrays melewatinya.
    onItemBound() {
      this.ensureTableArrays(PURCHASING_QM_TAB);
      this.preloadTabLabels(PURCHASING_QM_TAB);
    }
  }
};
</script>
